import { configureStore } from "@reduxjs/toolkit";
import gsReducer from './gsSlice';
import captchaReducer from './captchaSlice';
import languageReducer from './langSlice';
import userSlice from './userSlice';
import customPageReducer from './customPageSlice';
import extensionReducer from './extensionSlice';
import frontendReducer from './frontendSlice';
import pageTitleSlice from './pageTitleSlice';
import kycReducer from './kycSlice';
import belyftedTransferReducer from './belyftedTransferSlice';

export const store = configureStore({
    reducer: {
        gs: gsReducer,
        captcha: captchaReducer,
        language: languageReducer,
        user: userSlice,
        customPage: customPageReducer,
        extension: extensionReducer,
        frontend: frontendReducer,
        pageTitle: pageTitleSlice,
        kyc: kycReducer,
        belyftedTransfer: belyftedTransferReducer,
    }
});